import { Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import CreateModules from "../../components/createModules";
import Modules from "../../components/permissions/modules";
import CardSys from "../../components/cardSys";
import { AuthContext } from "../../contexts/AuthContext";
import TableGroups from "../../components/tableGroups";
import TitlePages from "../../components/generic/titlePages";
import SubTitlePages from "../../components/generic/subTitlePages";
import ModalSys from "../../components/modal";
import ButtonCreate from "../../components/buttonCreate";
import { api } from "../../services/api";
import FilterTableSys from "../../components/filterTableSys";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import ClientModules from "../../components/clientModules";
import { useNavigate } from "react-router-dom";

export default function Permission() {
  const [moduleViewUsers, setModuleViewUsers] = useState({ visible: false, group: null });
  const [moduleView, setModuleView] = useState({ visible: false });
  const [createModuleView, setCreateModuleView] = useState(false);
  const { user } = useContext(AuthContext);
  const [updateTable, setUpdateTable] = useState(false)
  const [clients, setClients] = useState([]);
  const [clientsView, setClientsView] = useState([]);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const navigate = useNavigate()


  const permissionGroup = [];
  user?.permission?.map((el) => {
    if (el.name == "Grupos de permissão") {
      permissionGroup.push(...el.permission);
    }
  });

  useEffect(() => {
    if (user?.id) {
      if (!permissionGroup.find((el) => el.name == "Visualizar") || user?.id_client != 25886008) {
        navigate("/notpermission")
      }
    }
  }, [user])

  const handleClickCard = (moduleClick) => {
    moduleClick.visible = true;
    setModuleView(moduleClick);
  };

  const handleBack = () => {
    setModuleView({ visible: false });
    setCreateModuleView(false);
    setModuleViewUsers({ visible: false });
  };

  useEffect(() => {
    getClients();
  }, []);

  async function getClients() {
    handleLoading(true);
    try {
      const { data: clients } = await api({ method: "GET", url: "/group" });
      setClients(clients);
      setClientsView(clients);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  }

  useEffect(() => {
    getClients();
  }, [updateTable]);

  const handleFilter = (value) => {
    if (value == "") {
      setClientsView(clients)
    } else {
      const listView = []
      clients.map(el => {
        const items = Object.values(el)
        const compare = []
        items.map(item => {
          if (item) {
            compare.push(item.toString())
          }
        })
        if (!!compare.find(item => item.toUpperCase().includes(value.toUpperCase()))) {
          listView.push(el)
        }
      })
      setClientsView(listView)
    }
  }

  return (
    <>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item>
          <TitlePages>Permissões</TitlePages>
        </Grid>
      </Grid>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item xs={12}>
          <FilterTableSys handleFilter={value => handleFilter(value)}>
          </FilterTableSys>
        </Grid>
      </Grid>
      <CardSys>
        <Grid
          container
          direction="row"
          justifyContent="end"
          alignItems="end"
        >
          <Grid
            item
            xs={6}
            direction="row"
            justifyContent="space-between"
            alignItems="center"

            sx={{ display: "flex" }}
          >
            <SubTitlePages sx={{ textAlign: "start" }}>
              {/* Perfil de acesso */}
            </SubTitlePages>
            {!!permissionGroup.find((el) => el.name == "Criar") ? (
              <ButtonCreate onClick={() => setCreateModuleView(true)}>
                Criar novo perfil de acesso
              </ButtonCreate>
            ) : null}
          </Grid>
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <TableGroups handleUsers={(group) => setModuleViewUsers({ visible: true, group })} clients={clientsView} handleEdit={handleClickCard}></TableGroups>
          </Grid>
        </Grid>
      </CardSys>
      {moduleView.visible ? (
        <ModalSys open={moduleView.visible} handleClose={handleBack}>
          <Modules
            updateTable={() => setUpdateTable(!updateTable)}
            id={moduleView?.id}
            title={moduleView?.name}
            handleBack={handleBack}
          ></Modules>
        </ModalSys>
      ) : null}
      {createModuleView ? (
        <ModalSys open={createModuleView} handleClose={handleBack}>
          <CreateModules updateTable={() => setUpdateTable(!updateTable)} handleEdit={({id, name, visible}) => setModuleView({id, name, visible}) } handleBack={handleBack}></CreateModules>
        </ModalSys>
      ) : null}
      {moduleViewUsers?.visible ?
        <ModalSys open={moduleViewUsers?.visible} handleClose={handleBack}>

          <ClientModules id={moduleViewUsers?.group?.id} title={moduleViewUsers?.group?.name} handleClose={handleBack}>
          </ClientModules>
        </ModalSys>

        : null
      }
    </>
  );
}
